import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

function Header() {
  const [navOpen, setNavOpen] = useState(false);
  const navRef = useRef(null);
  const toggleRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navOpen && 
          navRef.current && 
          !navRef.current.contains(event.target) &&
          !toggleRef.current.contains(event.target)) {
        setNavOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [navOpen]);

  const toggleNav = () => {
    setNavOpen(!navOpen);
  };

  return (
    <header>
      <Link to="/" className="logo">
        Griffith & McKee
      </Link>
      <div className="nav-toggle" onClick={toggleNav} ref={toggleRef}>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <nav ref={navRef}>
        <ul className={navOpen ? 'active' : ''}>
          <li>
            <Link to="/" onClick={() => setNavOpen(false)}>Home</Link>
          </li>
          <li>
            <Link to="/about" onClick={() => setNavOpen(false)}>About</Link>
          </li>
          <li>
            <Link to="/projects" onClick={() => setNavOpen(false)}>Projects</Link>
          </li>
          <li>
            <Link to="/services" onClick={() => setNavOpen(false)}>Services</Link>
          </li>
          <li>
            <Link to="/contact" onClick={() => setNavOpen(false)}>Contact</Link>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;